import { getLibraryByCategory } from "../../api/HttpApis";
import Button from "../../component/button/Button";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";

const useCreatorMovieData = () => {
  const MovieData = async (
    selectedDate,
    selectedCreator,
    selectedRating,
    selectedGenre,
    page,
    perpage
  ) => {
    try {
      const response = await getLibraryByCategory(
        "Movie",
        {},
        selectedDate,
        selectedCreator,
        selectedRating,
        selectedGenre,
        perpage,
        page
      );
      const data = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
      return data?.map((item) => ({
        // Try different possible field names for the original ID
        id: item.id || item.original_id || item.video_id || item.movie_id, // Original ID for API calls
        metadata_id: item.metadata_id || item.meta_id || item.meta_data_id, // Metadata ID for URL
        name: trimStr(item.name),
        media: item.portrait,
        status: item.status,
        qc_status: item.qc_status,
        qc_reason: item.qc_reason,
        qc_note: item.qc_note,
        type: item.type,
        access: item.access,
        submissionDate:
          new Date(item.dateUploaded).toLocaleDateString("en-US") || "N/A",
        buttonText: "Edit",
        buttonText2: "Remove",
        totalCount: response?.data?.total,
      }));
    } catch (error) {
      console.error("Failed to fetch movie data:", error.message || error);
      return [];
    }
  };

  const getColumns = (handleEdit, handleDelete, deletingId) => [
    {
      key: "name",
      label: "Name",
      render: (item) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            minWidth: 0,
          }}
        >
          {trimStr(item.name, 15)}
        </div>
      ),
    },
    {
      key: "media",
      label: "Media",
      render: (item) => (
        <img
          className="imageBox"
          src={item.media}
          alt="media"
          width={50}
          height={40}
        />
      ),
    },
    { key: "status", label: "Status" },
    { key: "type", label: "Type" },
    { key: "access", label: "Access" },
    { key: "submissionDate", label: "Submission Date" },
    {
      key: "buttonText",
      render: (item) => (
        <Button onClick={() => handleEdit(item.id, item.metadata_id)}>
          {item.buttonText}
        </Button>
      ),
    },
    {
      key: "buttonText2",
      render: (item) => (
        <Button
          onClick={() => handleDelete(item.id, item.metadata_id)}
          loading={deletingId === (item.metadata_id || item.id)}
          disabled={deletingId === (item.metadata_id || item.id)}
        >
          {item.buttonText2}
        </Button>
      ),
    },
  ];

  return {
    MovieData,
    getColumns,
  };
};

export default useCreatorMovieData;
